import React, { useState } from 'react';
import MaintenanceRequests from './MaintenanceRequests';
import MaintenanceCompanies from './MaintenanceCompanies';
import MaintenanceContracts from './MaintenanceContracts';
import { Wrench, Briefcase, FileText } from 'lucide-react';

const MaintenanceLayout: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'requests' | 'companies' | 'contracts'>('requests');

    return (
        <div className="animate-fadeIn">
            {/* Header / Tabs */}
            <div className="bg-white rounded-2xl p-2 mb-6 shadow-sm border border-slate-100 inline-flex gap-2">
                <button 
                    onClick={() => setActiveTab('requests')}
                    className={`flex items-center gap-2 px-6 py-3 rounded-xl transition-all font-bold ${activeTab === 'requests' ? 'bg-fly-600 text-white shadow-lg shadow-fly-600/20' : 'text-slate-500 hover:bg-slate-50'}`}
                >
                    <Wrench size={18} />
                    الطلبات
                </button>
                <button 
                    onClick={() => setActiveTab('companies')}
                    className={`flex items-center gap-2 px-6 py-3 rounded-xl transition-all font-bold ${activeTab === 'companies' ? 'bg-fly-600 text-white shadow-lg shadow-fly-600/20' : 'text-slate-500 hover:bg-slate-50'}`}
                >
                    <Briefcase size={18} />
                    شركات الصيانة
                </button>
                <button 
                    onClick={() => setActiveTab('contracts')}
                    className={`flex items-center gap-2 px-6 py-3 rounded-xl transition-all font-bold ${activeTab === 'contracts' ? 'bg-fly-600 text-white shadow-lg shadow-fly-600/20' : 'text-slate-500 hover:bg-slate-50'}`}
                >
                    <FileText size={18} />
                    العقود
                </button>
            </div>

            {/* Content Content - Kept Mounted for State Preservation if needed, or Conditional Render */}
            <div className="bg-transparent">
                {activeTab === 'requests' && <MaintenanceRequests />}
                {activeTab === 'companies' && <MaintenanceCompanies />}
                {activeTab === 'contracts' && <MaintenanceContracts />}
            </div>
        </div>
    );
};

export default MaintenanceLayout;
